import { AgentType } from "./types";

export const AVAILABLE_AGENT_TYPES = [
  {
    type: AgentType.LEASING_AGENT,
    label: "Leasing agent",
    description:
      "Qualify prospective tenants, answer questions about inventory and policies, create leads, and schedule showings.",
    singleInstance: true,
    features: [
      "Answer caller questions about inventory, showing availability, policies, etc. ",
      "Receive and/or re-route inbound calls",
      "Automatically draft responses to inbound texts & emails"
    ]
  },
  // Shown only to partners with underwriting agents on: the wizard filters it
  // with useUnderwritingAgentsEnabled.
  {
    type: AgentType.UNDERWRITING_AGENT,
    label: "Underwriting agent",
    description:
      "Reviews each screening report against your rules and flags what needs a closer look. It never approves, declines or changes an application; your team makes every decision.",
    singleInstance: true,
    features: [
      "Checks every report against rules you write in plain language",
      "Shows why each finding was flagged and links to the report",
      "Re-checks a report automatically whenever it updates"
    ]
  }
];

/**
 * Display name per agent type. Kept separate from AVAILABLE_AGENT_TYPES because
 * not every type is addable: the collection agent is granted by a feature flag,
 * so it needs a label in the table without appearing in the add-agent wizard.
 */
export const AGENT_TYPE_LABELS: Record<AgentType, string> = {
  [AgentType.LEASING_AGENT]: "Leasing agent",
  [AgentType.COLLECTION_AGENT]: "Collection agent",
  [AgentType.UNDERWRITING_AGENT]: "Underwriting agent"
};

export const COLLECTION_AGENT_DESCRIPTION =
  "Contact tenants with a past due balance by email, text and voice to bring overdue balances down. Hardship and exception requests are always handed to a person.";

export const agentsPath = "portal/v1/agents";

export const AGENTS_QUERY_KEY = ["AGENTS"];

export const agentQueryKey = (agentId: number | string) => [
  "AGENTS",
  String(agentId)
];
